<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!-- selection="multiple" -->
        <c-table
          ref="mstTable"
          title="기계기구유형"
          tableId="mstTable"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :filtering="false"
          :editable="editable"
          :columns="mstGrid.columns"
          :isExcelDown="false"
          :data="mstGrid.data"
          rowKey="code"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="추가" icon="add" @btnClicked="addrowType" v-if="editable" />
              <c-btn label="저장" icon="save" @btnClicked="saveType" v-if="editable" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props,col }">
            <template>
              <q-chip
                v-if="col.name==='openIns' && props.row.editFlag != 'C'"
                color="blue"
                :clickable="true"
                text-color="white"
                @click="rowClick(props.row, col.name)">
                ▶
              </q-chip>
            </template>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-table
          ref="grid"
          title="유형별 점검항목"
          tableId="table"
          :columns="grid.columns"
          :usePaging="false"
          :filtering="false"
          :isExcelDown="false"
          :data="grid.data"
          :editable="editable"
          selection="multiple"
          rowKey="hazardousMachineryTypeInsId"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="추가" icon="add" @btnClicked="addrowIns" v-if="editable && selectedRows.code && selectedRows.editFlag != 'C'" />
              <c-btn label="삭제" icon="remove" @btnClicked="removeRowIns" v-if="editable && selectedRows.code && selectedRows.editFlag != 'C'" />
              <c-btn label="저장" icon="save" @btnClicked="saveIns" v-if="editable && selectedRows.code && selectedRows.editFlag != 'C'" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazard-equipment-type-manage',
  data() {
    return {
      mstGrid: {
        columns: [
          {
            required: true,
            name: 'codeName',
            field: 'codeName',
            label: '기계기구유형',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            required: true,
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            style: 'width:70px',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width:70px',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'attrVal1',
            field: 'attrVal1',
            label: '공통관리대상',
            align: 'center',
            style: 'width:70px',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
          {
            name: 'openIns',
            field: 'openIns',
            label: '점검항목',
            align: 'center',
            style: 'width:80px',
            type: 'custom',
            sortable: false
          },
        ],
        data: [],
      },
      grid: {
        columns: [
          {
            required: true,
            name: 'typeName',
            field: 'typeName',
            label: '구분',
            align: 'left',
            style: 'width:250px',
            type: 'text',
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            style: 'width:70px',
            align: 'center',
            type: 'number',
            sortable: false,
          },
          {
            required: true,
            name: 'inspectItem',
            field: 'inspectItem',
            label: '점검항목',
            align: 'left',
            type: 'textarea',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      headerUrl: '',
      listUrl: '',
      selectedRows: {}
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getCodeMst();
    },
    getCodeMst() {
      this.selectedRows = {};
      this.grid.data = [];
      this.rowRemoveSelect();
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.url, 'HHM_TYPE_CD');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.mstGrid.data = _result.data;
      },
      () => {
      });
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1');
      if (_table.length > 0) {
        for(let c = 0; c <= _table.length; c++) {
          _table[c].classList.remove('bg-light-blue-1');
        }
      }
    },
    rowClick(row) {
      this.selectedRows = row;
      this.$http.url = selectConfig.sop.hhm.hazard.master.item.list.url
      this.$http.type = 'GET';
      this.$http.param = {hhmTypeCd: this.selectedRows.code};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    addrowType() {
      let len = this.mstGrid.data.length + 1;
      this.mstGrid.data.push({
        editFlag: 'C',
        codeGrpCd: 'HHM_TYPE_CD',  // 코드그룹
        code: uid(),  // 코드
        codeName: '',  // 코드명
        attrVal1: 'N', // 공통
        useFlag: 'Y',  // 사용여부
        sortOrder: len,  //
      });
    },
    saveType() {
      let checkItem = ['codeName', 'sortOrder']
      let isConti = true;
      this.$_.forEach(this.mstGrid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [기계기구유형]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.mstGrid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = transactionConfig.sop.hhm.hazard.master.type.save.url;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.getCodeMst();
                window.getApp.$emit('APP_REQUEST_SUCCESS');
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    addrowIns() {
      let len = this.grid.data.length + 1;
      this.grid.data.push({
        editFlag: 'C',
        hazardousMachineryTypeInsId: uid(),  // 기계기구별 점검항목일련번호
        hhmTypeCd: this.selectedRows.code,  // 기계기구코드
        typeName: '',  // 구분
        inspectItem: '',  // 자율점검항목
        sortOrder: len,  // 순번
      });
    },
    saveIns() {
      let checkItem = ['typeName', 'inspectItem']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [구분, 점검항목]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = transactionConfig.sop.hhm.hazard.master.item.save.url;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.rowClick(this.selectedRows);
                window.getApp.$emit('APP_REQUEST_SUCCESS');
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removeRowIns() {
      let selectData = this.$refs['grid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = transactionConfig.sop.hhm.hazard.master.item.delete.url;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.rowClick(this.selectedRows);
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, item);
              })
              this.$refs['grid'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
